// get location of user
console.log("location-detect.js loaded");

var userLocation;

$("#location-no").click(function () {
  console.log("click");
  	setCookieValue('location-check','1');
 	$("#shopify-section-redirect-modal").hide();
})

if(!getCookieValue('location-check')) {
  console.log('cookie check');
  console.log(getCookieValue('location-check'));
$.get('https://www.cloudflare.com/cdn-cgi/trace', function(cloudflare) {
  	  var data = cloudflare.replace(/[\r\n]+/g, '","').replaceAll(/\=+/g, '":"');
          data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';
      var jsondata = $.parseJSON(data);
      //console.log(jsondata.loc);
  		userLocation = jsondata.loc.toLowerCase().trim();


  if (userLocation !== 'us') {
      $(".age-gate").hide();
      $("#shopify-section-redirect-modal").css("display", "flex");
  }


});
};

function getCookieValue(name){
  console.log('getCookieValue');
  var value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
  console.log('cookievalue', value);
  return value;
};
  
  function setCookieValue(name,value){
  	console.log('setCookieValue');
  	console.log(document.cookie = name+"="+value);
};


